/* eslint-disable prettier/prettier */ // TODO: Reativar após normalizar EOL (Windows CRLF vs LF)
import { useCallback, useEffect, useState, type ReactNode } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import StraightenOutlinedIcon from "@mui/icons-material/StraightenOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import BrandingWatermarkOutlinedIcon from "@mui/icons-material/BrandingWatermarkOutlined";
import { Box, Stack, Typography } from "@mui/material";
import { LojaPageContainer } from "../../common";
import ProdutoFormSection from "./components/ProdutoFormSection";
import {
  emptyStateSx,
  modalHeaderSx,
  modalPaperSx,
  PRODUTO_FORM_ACCENT,
  produtoTabsSx,
  produtoToolbarSx,
  saveButtonSx,
  switchAccentSx,
} from "./produto-form.theme";
import {
  detalharProdutoByIdLoja,
  enviarImagensProdutoLoja,
  salvarEspecificacoesProdutoLoja,
  salvarTabelaTamanhoProdutoLoja,
  salvarVariacoesProdutoLoja,
  createOrEditProdutoLoja,
  removerImagemProdutoLoja,
  removerEspecificacaoProdutoLoja,
  vincularCategoriasProdutoLoja,
  desvincularCategoriasProdutoLoja,
} from "services/lojaProduto";
import { VariacoesPage } from "./Variacoes";
import CuponsPage from "./Cupons";
import { normalizarVariacoesDaApi } from "./Variacoes/helpers";
import type { IVariacaoProdutoPayload } from "interfaces/loja/variacaoProduto";
import type { IVariacaoProdutoState } from "interfaces/loja";

// import { uploadImagemLoja, excluirImagemLoja } from "services/lojaUploads";

import {
  IProdutoLoja,
  ICategoriaProduto,
  StatusProduto,
  IEspecificacaoProduto,
  ITabelaTamanho,
  IProdutoLojaCreate,
} from "interfaces/loja";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import FormField from "layouts/pages/account/components/FormField";
import { currencyMaskBRL, currencyToNumber } from "helpers/utils";
import {
  validateImageFilesMaxDimensions,
  PRODUTO_IMAGE_MAX_WIDTH,
  PRODUTO_IMAGE_MAX_HEIGHT,
} from "helpers/validateImageDimensions";
import ProdutoImageCropModal from "components/ProdutoImageCropModal";
import { getProdutoImageUploadPathFromUrl } from "helpers/produtoImagemUrl";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useMaterialUIController, setMessage } from "context";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import Icon from "@mui/material/Icon";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Skeleton from "@mui/material/Skeleton";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import { getAllEventos } from "services/evento";
import { getCategoriasArvore } from "services/lojaCategorias";
import { criarMarca, listarMarcas } from "services/lojaMarcas";
import type { IEventoResponse } from "interfaces/eventos";
import DropzoneGlobal from "components/DropzoneGlobal";
import Rating from "@mui/material/Rating";

function StatMini({
  label,
  value,
  accent,
}: {
  label: string;
  value: string | number;
  accent?: boolean;
}) {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid",
        borderColor: accent ? "rgba(249, 96, 48, 0.3)" : "grey.200",
        bgcolor: accent ? "rgba(249, 96, 48, 0.04)" : "background.paper",
        height: "100%",
      }}
    >
      <Typography
        variant="h4"
        fontWeight="bold"
        color={accent ? PRODUTO_FORM_ACCENT : "text.primary"}
        sx={{ fontSize: { xs: "1.25rem", sm: "2rem" } }}
      >
        {value}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}

function SubsectionTitle({ children }: { children: ReactNode }) {
  return (
    <MDTypography
      variant="overline"
      color="text.secondary"
      fontWeight="bold"
      sx={{ display: "block", letterSpacing: 1, mb: 1.5, mt: 1 }}
    >
      {children}
    </MDTypography>
  );
}

// Componente recursivo para árvore de categorias com Switch (estilo CupomFormVinculos)
function CategoriaTreeItem({
  categoria,
  level,
  expanded,
  onToggle,
  selecionadas,
  onToggleCategoria,
}: {
  categoria: ICategoriaProduto;
  level: number;
  expanded: Set<number>;
  onToggle: (id: number) => void;
  selecionadas: number[];
  onToggleCategoria: (categoria: ICategoriaProduto) => void;
}) {
  const hasChildren = Boolean(categoria.subcategorias?.length);
  const isExpanded = expanded.has(categoria.id);
  const checked = selecionadas.includes(categoria.id);

  return (
    <>
      <ListItem disablePadding sx={{ pl: level * 2.5, mb: 0.5 }}>
        <ListItemButton
          onClick={() => hasChildren && onToggle(categoria.id)}
          sx={{
            borderRadius: 1.5,
            py: 1,
            px: 1.5,
            border: "1px solid",
            borderColor: checked ? "rgba(249, 96, 48, 0.35)" : "divider",
            bgcolor: checked ? "rgba(249, 96, 48, 0.04)" : "transparent",
            "&:hover": { bgcolor: "rgba(249, 96, 48, 0.06)" },
          }}
        >
          {hasChildren ? (
            <Icon
              sx={{
                mr: 1.5,
                fontSize: 20,
                minWidth: 24,
                color: "text.secondary",
              }}
            >
              {isExpanded ? "expand_more" : "chevron_right"}
            </Icon>
          ) : (
            <MDBox width={24} mr={1.5} />
          )}
          <ListItemText
            primary={
              <MDBox display="flex" alignItems="center" gap={1.5}>
                <Switch
                  size="small"
                  checked={checked}
                  onChange={(e) => {
                    e.stopPropagation();
                    onToggleCategoria(categoria);
                  }}
                  onClick={(e) => e.stopPropagation()}
                  sx={switchAccentSx}
                />
                <MDTypography variant="body2" fontWeight="medium">
                  {categoria.nome}
                </MDTypography>
              </MDBox>
            }
          />
        </ListItemButton>
      </ListItem>
      {hasChildren && (
        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {categoria.subcategorias!.map((sub) => (
              <CategoriaTreeItem
                key={sub.id}
                categoria={sub}
                level={level + 1}
                expanded={expanded}
                onToggle={onToggle}
                selecionadas={selecionadas}
                onToggleCategoria={onToggleCategoria}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
}

// Retorna o ID da categoria + todos os IDs dos descendentes (para seleção em cascata)
function getIdsComDescendentes(categoria: ICategoriaProduto): number[] {
  const flat = flattenCategorias([categoria]);
  return flat.map((c) => c.id);
}

// Função auxiliar para flatten de categorias
function flattenCategorias(cats: ICategoriaProduto[]): ICategoriaProduto[] {
  const out: ICategoriaProduto[] = [];
  cats.forEach((c) => {
    out.push(c);
    if (c.subcategorias?.length)
      out.push(...flattenCategorias(c.subcategorias));
  });
  return out;
}

export default function LojaProdutoForm() {
  const navigate = useNavigate();
  const { produtoId } = useParams<{ produtoId: string }>();
  const [controller, dispatch] = useMaterialUIController();
  const editMode = Boolean(produtoId);

  // Eventos
  const [eventos, setEventos] = useState<IEventoResponse[]>([]);
  // Form
  const [form, setForm] = useState<
    IProdutoLoja & {
      ativo?: boolean;
      preco?: string;
      precoOriginal?: string;
      /** Centavos em string (mesmo padrão de preço original / máscara BRL). */
      precoCusto?: string;
      estoquePadrao?: number;
      emEstoquePadrao?: boolean;
    }
  >({
    id: "",
    nome: "",
    slug: "",
    descricao: "",
    emPromocao: false,
    emDestaque: false,
    status: StatusProduto.ATIVO,
    pesoKg: 0,
    larguraCm: 0,
    alturaCm: 0,
    comprimentoCm: 0,
    digital: false,
    urlDownload: "",
    eventoId: 0,
    freteGratis: false,
    retiradaNoLocal: false,
    mediaAvaliacoes: 0,
    qtdAvaliacoes: 0,
    createAt: "",
    updatedAt: "",
    imagens: [],
    especificacoes: [],
    tabelasTamanho: [],
    variacoes: [],
    categorias: [],
    avaliacoes: [],
    preco: "0",
    precoOriginal: "0",
    precoCusto: "0",
    ativo: true,
    estoquePadrao: 0,
    emEstoquePadrao: true,
  });

  const [arquivosParaUpload, setArquivosParaUpload] = useState<File[]>([]);
  const [dropzoneKey, setDropzoneKey] = useState(0);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [cropFile, setCropFile] = useState<File | null>(null);
  const [cropQueue, setCropQueue] = useState<File[]>([]);
  const [selectedPreviewIndex, setSelectedPreviewIndex] = useState(0);
  const [saving, setSaving] = useState(false);
  const [savingImagens, setSavingImagens] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(0);

  const [categoriasArvore, setCategoriasArvore] = useState<ICategoriaProduto[]>(
    []
  );
  const [categoriasSel, setCategoriasSel] = useState<number[]>([]);
  const [categoriasExpanded, setCategoriasExpanded] = useState<Set<number>>(
    new Set()
  );
  const [marcas, setMarcas] = useState<
    { id: number; nome: string; slug: string }[]
  >([]);
  const [openMarcaModal, setOpenMarcaModal] = useState(false);
  const [novaMarcaNome, setNovaMarcaNome] = useState("");
  const [savingMarca, setSavingMarca] = useState(false);
  // Variações simples
  const [variacoes, setVariacoes] = useState<any[]>([]);
  // Especificações e Tabela de tamanho (formato backend: chave, valor, ordem)
  const [especificacoes, setEspecificacoes] = useState<IEspecificacaoProduto[]>(
    []
  );
  // Tabelas de tamanho: array de { titulo, linhas: { campo, valor, ordem }[] }
  const [tabelas, setTabelas] = useState<ITabelaTamanho[]>([]);

  // Função auxiliar para carregar detalhes do produto
  /** Usa rota `produtoId`, ou `form.id` (fluxo /loja/produtos/create após criar o produto). */
  async function getDetalhesProduto(idParam?: string): Promise<void> {
    const id = String(
      idParam ?? produtoId ?? (form as { id?: string }).id ?? ""
    ).trim();
    if (!id) return;
    try {
      const { data } = await detalharProdutoByIdLoja(id);

      const variacaoPadrao =
        data.variacoes?.find((v: any) => v.isPadrao) ?? data.variacoes?.[0];

      const precoCentavos =
        variacaoPadrao?.preco != null
          ? String(Math.round(Number(variacaoPadrao.preco) * 100))
          : "0";
      const precoOriginalCentavos =
        variacaoPadrao?.precoOriginal != null &&
        Number(variacaoPadrao.precoOriginal) > 0
          ? String(Math.round(Number(variacaoPadrao.precoOriginal) * 100))
          : precoCentavos;
      const precoCustoCentavos =
        variacaoPadrao?.precoCusto != null &&
        Number(variacaoPadrao.precoCusto) > 0
          ? String(Math.round(Number(variacaoPadrao.precoCusto) * 100))
          : "0";
      setForm({
        ...data,
        ativo: data.status === StatusProduto.ATIVO,
        preco: precoCentavos,
        precoOriginal: precoOriginalCentavos,
        precoCusto: precoCustoCentavos,
        estoquePadrao: variacaoPadrao?.estoque ?? 0,
        emEstoquePadrao: (variacaoPadrao?.estoque ?? 0) > 0,
      });
      setEspecificacoes(data.especificacoes ?? []);
      setTabelas(data.tabelasTamanho ?? []);
      setVariacoes(data.variacoes ?? []);
      setCategoriasSel(
        (data.categorias ?? [])
          .map(
            (c: { id?: number; categoria?: { id: number } }) =>
              c.categoria?.id ?? c.id
          )
          .filter((id): id is number => typeof id === "number")
      );
      setSaving(true);
    } catch (error: any) {
      setMessage(dispatch, {
        open: true,
        severity: "error",
        text: error?.message || "Falha ao carregar detalhes do produto.",
      });
    }
  }

  // Resetar preview da galeria quando as imagens do produto mudam
  useEffect(() => {
    setSelectedPreviewIndex(0);
  }, [form.imagens?.length]);

  // Carregar eventos, categorias e produto
  useEffect(() => {
    (async () => {
      try {
        const [resultEventos, resultMarcas] = await Promise.all([
          getAllEventos(1, 100, "active"),
          listarMarcas().catch(() => ({ data: [] as any[] })),
        ]);
        setEventos(resultEventos.eventos);
        setMarcas(Array.isArray(resultMarcas.data) ? resultMarcas.data : []);

        if (produtoId) {
          await getDetalhesProduto();
        }
      } catch (error: any) {
        setLoading(false);
        setMessage(dispatch, {
          open: true,
          severity: "error",
          text: error?.message || "Falha na comunicação com o servidor.",
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [produtoId]);

  const abrirFilaRecorte = (files: File[]) => {
    if (!files.length) return;
    setCropQueue(files);
    setCropFile(files[0]);
    setCropModalOpen(true);
  };

  const processarArquivosImagem = useCallback(
    async (files: File[]) => {
      if (!files.length) return;

      const invalid = await validateImageFilesMaxDimensions(
        files,
        PRODUTO_IMAGE_MAX_WIDTH,
        PRODUTO_IMAGE_MAX_HEIGHT,
      );
      const invalidSet = new Set(invalid.map((i) => i.file));
      const valid = files.filter((f) => !invalidSet.has(f));

      if (valid.length > 0) {
        setArquivosParaUpload((prev) => [...prev, ...valid]);
      }
      setDropzoneKey((k) => k + 1);

      if (invalid.length > 0) {
        abrirFilaRecorte(invalid.map((i) => i.file));
        setMessage(dispatch, {
          open: true,
          severity: "info",
          text:
            invalid.length === 1
              ? "A imagem excede o tamanho permitido. Ajuste o recorte no quadro."
              : `${invalid.length} imagens excedem o tamanho permitido. Ajuste o recorte de cada uma.`,
        });
      }
    },
    [dispatch],
  );

  const handleCropConfirm = useCallback((cropped: File) => {
    setArquivosParaUpload((prev) => [...prev, cropped]);
    setCropQueue((queue) => {
      const rest = queue.slice(1);
      if (rest.length > 0) {
        setCropFile(rest[0]);
        return rest;
      }
      setCropModalOpen(false);
      setCropFile(null);
      return [];
    });
    setMessage(dispatch, {
      open: true,
      severity: "success",
      text: "Imagem recortada e adicionada à lista de envio.",
    });
  }, [dispatch]);

  const handleCropClose = () => {
    setCropModalOpen(false);
    setCropFile(null);
    setCropQueue([]);
  };

  const handleSalvarNovaMarca = async () => {
    const nome = novaMarcaNome.trim();
    if (!nome) {
      setMessage(dispatch, {
        open: true,
        severity: "warning",
        text: "Informe o nome da marca.",
      });
      return;
    }
    setSavingMarca(true);
    try {
      const marca = await criarMarca({ nome, ativo: true });
      const item = { id: marca.id, nome: marca.nome, slug: marca.slug };
      setMarcas((prev) =>
        [...prev, item].sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"))
      );
      setForm((f: any) => ({ ...f, marcaId: marca.id }));
      setOpenMarcaModal(false);
      setNovaMarcaNome("");
      setMessage(dispatch, {
        open: true,
        severity: "success",
        text: "Marca cadastrada e selecionada.",
      });
    } catch (error: any) {
      setMessage(dispatch, {
        open: true,
        severity: "error",
        text:
          error?.response?.data?.error ??
          error?.message ??
          "Falha ao cadastrar marca.",
      });
    } finally {
      setSavingMarca(false);
    }
  };

  // Função auxiliar para excluir imagem da galeria
  async function onExcluirImagemGaleria(img: any) {
    const pathRelativo = getProdutoImageUploadPathFromUrl(img.url);
    if (!pathRelativo) return;
    try {
      const result = await removerImagemProdutoLoja(
        encodeURIComponent(pathRelativo)
      );
      if (result.status === 200) {
        setForm((prev) => ({
          ...prev,
          imagens: prev.imagens.filter((i: any) => i.url !== img.url),
        }));
        setSelectedPreviewIndex((idx) => Math.max(0, idx - 1));
        setMessage(dispatch, {
          open: true,
          severity: "success",
          text: "Imagem removida.",
        });
      }
    } catch (error: any) {
      setMessage(dispatch, {
        open: true,
        severity: "error",
        text: error?.message || "Falha ao remover imagem.",
      });
    }
  }

  // Função auxiliar para mover item em uma lista
  function moveItem<T>(list: T[], index: number, dir: -1 | 1): T[] {
    const arr = [...list];
    const newIndex = index + dir;
    if (newIndex < 0 || newIndex >= arr.length) return arr;
    const [m] = arr.splice(index, 1);
    arr.splice(newIndex, 0, m as T);
    return arr;
  }

  // Função auxiliar para expandir/contrair a árvore de categorias
  const toggleCategoriasExpanded = useCallback((id: number) => {
    setCategoriasExpanded((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  // Função auxiliar para carregar categorias disponíveis
  async function getCategoriasDisponiveis() {
    try {
      if (categoriasArvore.length > 0) return;
      const resultCategorias = await getCategoriasArvore();

      setCategoriasArvore(resultCategorias.data || []);
    } catch (error: any) {
      setMessage(dispatch, {
        open: true,
        severity: "error",
        text: error?.message || "Falha ao carregar categorias.",
      });
    }
  }

  // Salvar dados do produto (payload alinhado ao backend: nome, descricao, categoriaId, ativo, etc.)
  async function onSalvarDados(): Promise<boolean> {
    try {
      if (!String(form.nome || "").trim()) {
        setMessage(dispatch, {
          open: true,
          severity: "error",
          text: "Nome é obrigatório.",
        });
        return false;
      }
      const pesoKgNum = Number(form.pesoKg) || 0;
      const larguraCmNum = Number(form.larguraCm) || 0;
      const alturaCmNum = Number(form.alturaCm) || 0;
      const comprimentoCmNum = Number(form.comprimentoCm) || 0;
      const eventoIdNum = form.eventoId ? Number(form.eventoId) : null;

      const payload: IProdutoLojaCreate = {
        nome: String(form.nome).trim(),
        descricao: String(form.descricao ?? "").trim(),
        status: form.ativo ? StatusProduto.ATIVO : StatusProduto.INATIVO,
        emPromocao: Boolean(form.emPromocao),
        emDestaque: Boolean(form.emDestaque),
        pesoKg: pesoKgNum,
        larguraCm: larguraCmNum,
        alturaCm: alturaCmNum,
        comprimentoCm: comprimentoCmNum,
        digital: Boolean(form.digital),
        urlDownload: form.digital ? String(form.urlDownload) : "",
        eventoId: eventoIdNum,
        freteGratis: Boolean(form.freteGratis),
        retiradaNoLocal: Boolean(form.retiradaNoLocal),
        marcaId: form.marcaId ?? null,
        preco: form.emPromocao
          ? currencyToNumber(form.preco ?? "0")
          : currencyToNumber(form.precoOriginal ?? "0"),
        precoOriginal: form.emPromocao
          ? currencyToNumber(form.precoOriginal ?? "0")
          : null,
        emEstoque: Number(form.estoquePadrao ?? 0) > 0,
        estoquePadrao: Number(form.estoquePadrao ?? 0),
      };

      if (editMode && form.id) payload.id = form.id;

      // API: Criar ou atualizar produto
      const result = await createOrEditProdutoLoja(payload);

      //Backend: 201 = criar, 200 = atualizar (produto.controller criarOuEditarProdutoGerenciarHandler)
      if (result.status === 201 || result.status === 200) {
        const productData = result.data;
        setForm((prev) => ({
          ...prev,
          ...productData,
          preco: String(Math.round(Number(productData.preco) * 100)) ?? "0",
        }));
        setSaving(true);
        setTab(1); // Ir para a aba de imagens

        const precoPadraoNum = form.emPromocao
          ? (() => {
              const v = currencyToNumber(form.preco ?? "0");
              return Number.isFinite(v) ? v : 0;
            })()
          : (() => {
              const v = currencyToNumber(form.precoOriginal ?? "0");
              return Number.isFinite(v) ? v : 0;
            })();
        const precoOriginalPadraoNum = form.emPromocao
          ? (() => {
              const v = currencyToNumber(form.precoOriginal ?? "0");
              return Number.isFinite(v) ? v : 0;
            })()
          : 0;
        const precoCustoPadraoNum = (() => {
          const v = currencyToNumber(form.precoCusto ?? "0");
          if (!Number.isFinite(v) || v <= 0) return null;
          return v;
        })();
        const estoquePadraoNum = Number(form.estoquePadrao) || 0;
        const variacoesAtual = productData.variacoes ?? form.variacoes ?? [];
        const variacaoPadrao =
          variacoesAtual.find((v: any) => v.isPadrao) ?? variacoesAtual[0];

        try {
          if (variacoesAtual.length === 0) {
            const variacaoPadraoPayload: IVariacaoProdutoPayload = {
              sku: "",
              preco: precoPadraoNum,
              precoOriginal: precoOriginalPadraoNum,
              precoCusto: precoCustoPadraoNum,
              estoque: estoquePadraoNum,
              emEstoque: estoquePadraoNum > 0,
              isPadrao: true,
              atributos: [],
            };

            const { data: dataComVariacao } = await salvarVariacoesProdutoLoja(
              String(productData.id),
              [variacaoPadraoPayload]
            );

            const variacoesCriadas = dataComVariacao?.variacoes ?? [
              variacaoPadraoPayload,
            ];
            setForm((prev) => ({
              ...prev,
              ...dataComVariacao,
              variacoes: variacoesCriadas as any[],
            }));
            setVariacoes(normalizarVariacoesDaApi(variacoesCriadas));
          } else if (
            variacaoPadrao &&
            (precoPadraoNum > 0 || estoquePadraoNum >= 0)
          ) {
            // Já existe variação: atualizar preço/estoque da padrão
            const variacoesToSave = variacoesAtual.map((v: any) =>
              v.id === variacaoPadrao.id || v.isPadrao
                ? {
                    ...v,
                    preco: precoPadraoNum,
                    precoOriginal: precoOriginalPadraoNum,
                    precoCusto: precoCustoPadraoNum,
                    estoque: estoquePadraoNum,
                    emEstoque: estoquePadraoNum > 0,
                  }
                : v
            );
            const { data: dataAtualizada } = await salvarVariacoesProdutoLoja(
              String(productData.id),
              variacoesToSave
            );
            const variacoesAtualizadas =
              dataAtualizada?.variacoes ?? variacoesToSave;
            setForm((prev) => ({
              ...prev,
              ...dataAtualizada,
              variacoes: variacoesAtualizadas as any[],
            }));
            setVariacoes(normalizarVariacoesDaApi(variacoesAtualizadas));
          }
        } catch {
          // ignora falha; produto já foi salvo
        }

        setMessage(dispatch, {
          open: true,
          severity: "success",
          text: editMode
            ? "Dados do produto salvos."
            : "Produto criado. Continue nas outras abas para completar o cadastro.",
        });

        return true;
      }
      return false;
    } catch (error: any) {
      setMessage(dispatch, {
        open: true,
        severity: "error",
        text: error?.message || "Falha na comunicação com o servidor.",
      });
    }
    return false;
  }

  // Salvar imagens do produto (sempre vinculadas à variação padrão na loja_produto_imagens)
  async function onSalvarImagens() {
    const id = String(produtoId || form.id || "");

    if (!id)
      return setMessage(dispatch, {
        open: true,
        severity: "error",
        text: "Crie o produto na aba Dados antes de salvar imagens.",
      });

    if (!arquivosParaUpload.length)
      return setMessage(dispatch, {
        open: true,
        severity: "error",
        text: "Selecione ao menos uma imagem no campo acima.",
      });

    const invalidDimensions = await validateImageFilesMaxDimensions(
      arquivosParaUpload,
      PRODUTO_IMAGE_MAX_WIDTH,
      PRODUTO_IMAGE_MAX_HEIGHT,
    );
    if (invalidDimensions.length > 0) {
      abrirFilaRecorte(invalidDimensions.map((i) => i.file));
      return setMessage(dispatch, {
        open: true,
        severity: "info",
        text: "Ajuste o recorte das imagens que excedem o tamanho permitido.",
      });
    }

    const MAX_IMAGENS_POR_VARIACAO = 5;
    const variacaoPadrao = (form.variacoes ?? []).find((v: any) => v.isPadrao);
    const variacaoPadraoId = variacaoPadrao?.id;
    const idRealVariacao =
      variacaoPadraoId && !String(variacaoPadraoId).startsWith("var-")
        ? variacaoPadraoId
        : undefined;
    const imagensAtuaisVariacaoPadrao =
      form.imagens?.filter(
        (img: any) =>
          img.variacaoProdutoId === null ||
          img.variacaoProdutoId === undefined ||
          String(img.variacaoProdutoId) === String(variacaoPadraoId)
      ) ?? [];
    if (
      imagensAtuaisVariacaoPadrao.length + arquivosParaUpload.length >
      MAX_IMAGENS_POR_VARIACAO
    ) {
      return setMessage(dispatch, {
        open: true,
        severity: "error",
        text: `Máximo de ${MAX_IMAGENS_POR_VARIACAO} imagens por variação. Você tem ${imagensAtuaisVariacaoPadrao.length} e tentou adicionar ${arquivosParaUpload.length}.`,
      });
    }

    setSavingImagens(true);

    try {
      await enviarImagensProdutoLoja({
        produtoId: id,
        variacaoProdutoId: idRealVariacao,
        arquivos: arquivosParaUpload,
      });

      await getDetalhesProduto();

      setMessage(dispatch, {
        open: true,
        severity: "success",
        text: "Imagens salvas.",
      });

      setArquivosParaUpload([]);
      setDropzoneKey((k) => k + 1);
    } catch (err: any) {
      setMessage(dispatch, {
        open: true,
        severity: "error",
        text: err?.message || "Falha ao enviar imagens.",
      });
    } finally {
      setSavingImagens(false);
    }
  }

  // Função auxiliar para salvar especificações do produto
  async function onSalvarEspecificacoes() {
    const id = String(produtoId ?? form.id ?? "");

    if (!id)
      return setMessage(dispatch, {
        open: true,
        severity: "error",
        text: "Crie o produto na aba Dados antes de salvar especificações.",
      });

    // Verificar se existe especificações
    if (!especificacoes.length) {
      return setMessage(dispatch, {
        open: true,
        severity: "error",
        text: "Crie as especificações antes de salvar.",
      });
    }

    try {
      await salvarEspecificacoesProdutoLoja({
        produtoId: id,
        especificacoes: especificacoes,
      });

      setMessage(dispatch, {
        open: true,
        severity: "success",
        text: "Especificações salvas.",
      });
    } catch (error: any) {
      setMessage(dispatch, {
        open: true,
        severity: "error",
        text: error?.message || "Falha ao salvar especificações.",
      });
    }
  }

  // Função auxiliar para remover especificação do produto
  async function removeEspecificacao(especificacaoId: number, index: number) {
    if (!especificacaoId) return;

    try {
      await removerEspecificacaoProdutoLoja(especificacaoId);
    } catch (error: any) {
      setMessage(dispatch, {
        open: true,
        severity: "error",
        text: error?.message || "Falha ao remover especificação.",
      });
    }
    setEspecificacoes((prev) =>
      prev
        .filter((_, i) => i !== index)
        .map((it, i) => ({ ...it, ordem: i + 1 }))
    );
  }

  // Função auxiliar para salvar tabela de tamanho do produto
  async function onSalvarTabela() {
    const id = String(produtoId || form.id || "");

    if (!id)
      return setMessage(dispatch, {
        open: true,
        severity: "error",
        text: "Crie o produto na aba Dados antes de salvar as tabelas.",
      });

    try {
      const payload = tabelas.map((t) => ({
        titulo: t.titulo || "Tabela",
        linhas: t.linhas.map((l, i) => ({
          campo: l.campo,
          valor: l.valor,
          ordem: i + 1,
        })),
      }));

      await salvarTabelaTamanhoProdutoLoja(id, payload);

      setMessage(dispatch, {
        open: true,
        severity: "success",
        text: "Tabelas de tamanho salvas.",
      });
    } catch (error: any) {
      setMessage(dispatch, {
        open: true,
        severity: "error",
        text: error?.message || "Falha ao salvar tabelas de tamanho.",
      });
    }
  }

  // Função auxiliar para remover linha da tabela de tamanho do produto
  function removerLinhaTabela(
    arr: ITabelaTamanho[],
    tIdx: number,
    lIdx: number
  ): ITabelaTamanho[] {
    return arr.map((t, i) =>
      i === tIdx
        ? {
            ...t,
            linhas: (t.linhas ?? [])
              .filter((_, j) => j !== lIdx)
              .map((l, j) => ({ ...l, ordem: j + 1 })),
          }
        : t
    );
  }

  // Função auxiliar para salvar categorias do produto
  async function onSalvarCategorias() {
    const id = String(produtoId || (form as any).id || "");
    if (!id)
      return setMessage(dispatch, {
        open: true,
        severity: "error",
        text: "Crie o produto na aba Dados antes de salvar categorias.",
      });
    const idsAtuais = (form.categorias ?? [])
      .map(
        (c: { id?: number; categoria?: { id: number } }) =>
          c.categoria?.id ?? c.id
      )
      .filter((id): id is number => typeof id === "number");
    const paraAdicionar = categoriasSel.filter((id) => !idsAtuais.includes(id));
    const paraRemover = idsAtuais.filter((id) => !categoriasSel.includes(id));

    try {
      if (paraAdicionar.length > 0) {
        await vincularCategoriasProdutoLoja(id, paraAdicionar);
      }
      if (paraRemover.length > 0) {
        await desvincularCategoriasProdutoLoja(id, paraRemover);
      }
      if (paraAdicionar.length > 0 || paraRemover.length > 0) {
        setMessage(dispatch, {
          open: true,
          severity: "success",
          text: "Categorias atualizadas.",
        });
        await getDetalhesProduto();
      } else {
        setMessage(dispatch, {
          open: true,
          severity: "info",
          text: "Nenhuma alteração nas categorias.",
        });
      }
    } catch (error: any) {
      setMessage(dispatch, {
        open: true,
        severity: "error",
        text: error?.message ?? "Falha ao salvar categorias.",
      });
    }
  }

  // Função auxiliar para expandir/contrair a árvore de categorias
  useEffect(() => {
    if (categoriasArvore.length) {
      setCategoriasExpanded(new Set(categoriasArvore.map((c) => c.id)));
    }
  }, [categoriasArvore]);

  const produtoPersistido = Boolean(String(produtoId ?? form.id ?? "").trim());
  const tabLabels = [
    "Dados",
    "Imagens",
    "Especificações",
    "Tabela de Tamanho",
    "Variações",
    "Categorias",
    "Cupons",
  ];

  const formStats = {
    imagens: form.imagens?.length ?? 0,
    variacoes: variacoes.length,
    categorias: categoriasSel.length,
    especificacoes: especificacoes.length,
  };

  // Renderização do formulário de produto
  return (
    <LojaPageContainer
      title={editMode ? "Editar produto" : "Novo produto"}
      subtitle={
        form.nome
          ? String(form.nome)
          : "Cadastre os dados, imagens, variações e categorias do item na loja."
      }
      actions={
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          {!loading && tab === 0 ? (
            <MDButton
              variant="gradient"
              color="dark"
              size="small"
              onClick={() => void onSalvarDados()}
              sx={saveButtonSx}
            >
              <Icon sx={{ mr: 0.5, fontSize: "1rem !important" }}>save</Icon>
              {editMode ? "Salvar dados" : "Criar produto"}
            </MDButton>
          ) : null}
          {produtoPersistido ? (
            <Chip
              size="small"
              label={form.ativo ? "Ativo" : "Inativo"}
              color={form.ativo ? "success" : "default"}
            />
          ) : null}
          {Number(form.mediaAvaliacoes ?? 0) > 0 ? (
            <Rating
              name="half-rating-read"
              size="small"
              value={form.mediaAvaliacoes}
              precision={0.5}
              readOnly
            />
          ) : null}
          <MDButton
            variant="outlined"
            color="dark"
            size="small"
            startIcon={<ArrowBackOutlinedIcon />}
            onClick={() => navigate("/loja/produtos")}
          >
            Voltar
          </MDButton>
        </Stack>
      }
    >
      {loading ? (
        <MDBox>
          <MDBox sx={produtoToolbarSx} mb={2}>
            <Skeleton variant="text" width="60%" height={28} />
          </MDBox>
          <Grid container spacing={2} mb={3}>
            {[1, 2, 3, 4].map((i) => (
              <Grid item xs={6} sm={3} key={i}>
                <Skeleton variant="rounded" height={72} sx={{ borderRadius: 2 }} />
              </Grid>
            ))}
          </Grid>
          <Skeleton variant="rounded" height={48} sx={{ mb: 2, borderRadius: 1 }} />
          <Skeleton variant="rounded" height={320} sx={{ borderRadius: 2 }} />
        </MDBox>
      ) : (
        <>
          <Grid container spacing={2} mb={3}>
            <Grid item xs={6} sm={3}>
              <StatMini label="Etapa atual" value={tab + 1} accent />
            </Grid>
            <Grid item xs={6} sm={3}>
              <StatMini
                label="Status"
                value={produtoPersistido ? "Salvo" : "Rascunho"}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <StatMini label="Imagens" value={formStats.imagens} />
            </Grid>
            <Grid item xs={6} sm={3}>
              <StatMini label="Variações" value={formStats.variacoes} />
            </Grid>
          </Grid>

          <MDBox sx={produtoToolbarSx}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Inventory2OutlinedIcon sx={{ color: PRODUTO_FORM_ACCENT }} />
              <MDTypography variant="button" fontWeight="medium" color="text">
                {produtoPersistido
                  ? `Produto cadastrado — etapa: ${tabLabels[tab]}`
                  : "Preencha os dados e clique em Criar produto para liberar as demais abas"}
              </MDTypography>
            </Stack>
          </MDBox>

          <Tabs
            value={tab}
            onChange={(_, v) => {
              setTab(v);
              if (v === 5) {
                getCategoriasDisponiveis();
              }
            }}
            variant="scrollable"
            scrollButtons="auto"
            sx={produtoTabsSx}
          >
            <Tab label="Dados" />
            <Tab label="Imagens" disabled={!produtoPersistido} />
            <Tab label="Especificações" disabled={!produtoPersistido} />
            <Tab label="Tabela de Tamanho" disabled={!produtoPersistido} />
            <Tab label="Variações" disabled={!produtoPersistido} />
            <Tab label="Categorias" disabled={!produtoPersistido} />
            <Tab label="Cupons" disabled={!produtoPersistido} />
          </Tabs>

          {/* Dados */}
          {tab === 0 && (
            <ProdutoFormSection
              title="Dados do produto"
              subtitle="Nome, descrição, dimensões, preço e estoque da variação padrão."
              icon={<InfoOutlinedIcon />}
            >
              <Grid container spacing={3} sx={{ py: 0 }}>
                <Grid item xs={12}>
                  <SubsectionTitle>Informações básicas</SubsectionTitle>
                </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormField
                      label="Nome"
                      name="nome"
                      required
                      variant="outlined"
                      value={form.nome || ""}
                      onChange={(e: any) =>
                        setForm((f: any) => ({ ...f, nome: e.target.value }))
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <MDBox display="flex" flexWrap="wrap" gap={3}>
                      <MDTypography
                        variant="caption"
                        color="text.secondary"
                        fontWeight="medium"
                      >
                        Situação do produto
                      </MDTypography>
                    </MDBox>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={Boolean(form.ativo)}
                          onChange={(e) =>
                            setForm((f: any) => ({
                              ...f,
                              ativo: e.target.checked,
                            }))
                          }
                          sx={switchAccentSx}
                        />
                      }
                      label="Ativo"
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3} sx={{ py: 1 }}>
                  <Grid item xs={12}>
                    <SubsectionTitle>Visibilidade e tipo</SubsectionTitle>
                  </Grid>
                  <Grid item xs={12}>
                    <MDBox display="flex" flexWrap="wrap" gap={3}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={Boolean(form.emPromocao)}
                            onChange={(e) => {
                              const emPromocao = e.target.checked;
                              setForm((f: any) => ({
                                ...f,
                                emPromocao,
                                precoOriginal: emPromocao
                                  ? f.precoOriginal
                                  : (f.preco ?? f.precoOriginal ?? "0"),
                              }));
                            }}
                            sx={switchAccentSx}
                          />
                        }
                        label="Em promoção"
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={Boolean(form.emDestaque)}
                            onChange={(e) =>
                              setForm((f: any) => ({
                                ...f,
                                emDestaque: e.target.checked,
                              }))
                            }
                            sx={switchAccentSx}
                          />
                        }
                        label="Em destaque"
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={Boolean(form.digital)}
                            onChange={(e) =>
                              setForm((f: any) => ({
                                ...f,
                                digital: e.target.checked,
                              }))
                            }
                            sx={switchAccentSx}
                          />
                        }
                        label="Produto digital"
                      />
                    </MDBox>
                  </Grid>
                </Grid>

                <Grid container spacing={3} sx={{ py: 1 }}>
                  <Grid item xs={12}>
                    <SubsectionTitle>Dimensões, descrição e vínculos</SubsectionTitle>
                  </Grid>
                  {form.digital && (
                    <Grid item xs={12}>
                      <FormField
                        label="URL de download"
                        name="urlDownload"
                        variant="outlined"
                        disabled={!form.digital}
                        value={form.urlDownload || ""}
                        onChange={(e: any) =>
                          setForm((f: any) => ({
                            ...f,
                            urlDownload: e.target.value,
                          }))
                        }
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={3}>
                    <FormField
                      label="Peso (Kg)"
                      name="pesoKg"
                      type="number"
                      variant="outlined"
                      value={form.pesoKg ?? ""}
                      onChange={(e: any) =>
                        setForm((f: any) => ({
                          ...f,
                          pesoKg: e.target.value,
                        }))
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <FormField
                      label="Largura (cm)"
                      name="larguraCm"
                      type="number"
                      variant="outlined"
                      value={form.larguraCm ?? ""}
                      onChange={(e: any) =>
                        setForm((f: any) => ({
                          ...f,
                          larguraCm: e.target.value,
                        }))
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <FormField
                      label="Altura (cm)"
                      name="alturaCm"
                      type="number"
                      variant="outlined"
                      value={form.alturaCm ?? ""}
                      onChange={(e: any) =>
                        setForm((f: any) => ({
                          ...f,
                          alturaCm: e.target.value,
                        }))
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <FormField
                      label="Comprimento (cm)"
                      name="comprimentoCm"
                      type="number"
                      variant="outlined"
                      value={form.comprimentoCm ?? ""}
                      onChange={(e: any) =>
                        setForm((f: any) => ({
                          ...f,
                          comprimentoCm: e.target.value,
                        }))
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormField
                      label="Descrição"
                      name="descricao"
                      variant="outlined"
                      multiline
                      minRows={8}
                      maxRows={25}
                      value={form.descricao || ""}
                      onChange={(e: any) =>
                        setForm((f: any) => ({
                          ...f,
                          descricao: e.target.value,
                        }))
                      }
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ style: { height: "auto", minHeight: 80 } }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <MDBox display="flex" alignItems="flex-start" gap={1}>
                      <MDBox flex={1}>
                        <Autocomplete
                          value={
                            marcas.find((m) => m.id === form.marcaId) ?? null
                          }
                          options={marcas}
                          getOptionLabel={(option) => option?.nome ?? ""}
                          isOptionEqualToValue={(option, value) =>
                            option?.id === value?.id
                          }
                          onChange={(_, newValue) =>
                            setForm((f: any) => ({
                              ...f,
                              marcaId: newValue?.id ?? null,
                            }))
                          }
                          renderInput={(params) => (
                            <FormField
                              {...params}
                              variant="outlined"
                              label="Marca (opcional)"
                              InputLabelProps={{ shrink: true }}
                            />
                          )}
                        />
                      </MDBox>
                      <Tooltip title="Cadastrar nova marca">
                        <IconButton
                          onClick={() => {
                            setNovaMarcaNome("");
                            setOpenMarcaModal(true);
                          }}
                          sx={{ mt: 1, color: PRODUTO_FORM_ACCENT }}
                          aria-label="Cadastrar nova marca"
                        >
                          <Icon>add</Icon>
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Autocomplete
                      // ListboxProps={{
                      //   onScroll: (event: React.UIEvent<HTMLUListElement>) => {
                      //     const listboxNode = event.currentTarget;

                      //     const isBottom =
                      //       listboxNode.scrollTop + listboxNode.clientHeight >=
                      //       listboxNode.scrollHeight - 5; // tolerância

                      //     if (isBottom) {
                      //       console.log("Chegou no final!");
                      //       carregarProximaPaginaEventos();
                      //     }
                      //   },
                      // }}
                      value={
                        eventos.find((e) => e.id === form.eventoId) || null
                      }
                      options={eventos}
                      getOptionLabel={(option) => option?.titulo || ""}
                      isOptionEqualToValue={(option, value) =>
                        option?.id === value?.id
                      }
                      onChange={(_, newValue) =>
                        setForm((f: any) => ({
                          ...f,
                          eventoId: newValue?.id ?? null,
                        }))
                      }
                      renderInput={(params) => (
                        <FormField
                          {...params}
                          variant="outlined"
                          label="Evento (opcional)"
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />
                <SubsectionTitle>Preço e estoque (variação padrão)</SubsectionTitle>
                <MDTypography
                  variant="caption"
                  color="text.secondary"
                  sx={{ display: "block", mb: 2 }}
                >
                  Defina os valores da variação padrão do produto, incluindo
                  preço de venda, custo interno e quantidade em estoque.
                </MDTypography>
                <Grid container spacing={3} sx={{ py: 1 }}>
                  <Grid item xs={12} sm={form.emPromocao ? 3 : 4}>
                    <FormField
                      label="Preço (R$)"
                      name="precoOriginal"
                      type="text"
                      variant="outlined"
                      value={currencyMaskBRL(form.precoOriginal ?? "0")}
                      onFocus={(e: React.FocusEvent<HTMLInputElement>) =>
                        e.target.select()
                      }
                      onChange={(e: any) =>
                        setForm((f: any) => ({
                          ...f,
                          precoOriginal: (e.target.value || "").replace(
                            /\D/g,
                            ""
                          ),
                        }))
                      }
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ min: 0 }}
                    />
                  </Grid>
                  {form.emPromocao && (
                    <Grid item xs={12} sm={3}>
                      <FormField
                        label="Preço em promoção (R$)"
                        name="preco"
                        type="text"
                        variant="outlined"
                        value={currencyMaskBRL(form.preco ?? "0")}
                        onFocus={(e: React.FocusEvent<HTMLInputElement>) =>
                          e.target.select()
                        }
                        onChange={(e: any) =>
                          setForm((f: any) => ({
                            ...f,
                            preco: (e.target.value || "").replace(/\D/g, ""),
                          }))
                        }
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ min: 0 }}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={form.emPromocao ? 3 : 4}>
                    <FormField
                      label="Preço de custo (R$)"
                      name="precoCusto"
                      type="text"
                      variant="outlined"
                      value={currencyMaskBRL(form.precoCusto ?? "0")}
                      onFocus={(e: React.FocusEvent<HTMLInputElement>) =>
                        e.target.select()
                      }
                      onChange={(e: any) =>
                        setForm((f: any) => ({
                          ...f,
                          precoCusto: (e.target.value || "").replace(/\D/g, ""),
                        }))
                      }
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ min: 0 }}
                      helperText="Uso interno; não aparece na loja."
                    />
                  </Grid>
                  <Grid item xs={12} sm={form.emPromocao ? 3 : 4}>
                    <FormField
                      label="Estoque"
                      name="estoquePadrao"
                      type="number"
                      variant="outlined"
                      value={form.estoquePadrao ?? 0}
                      onChange={(e: any) => {
                        const valor = Number(e.target.value) || 0;
                        setForm((f: any) => ({
                          ...f,
                          estoquePadrao: valor,
                          emEstoquePadrao: valor > 0,
                        }));
                      }}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ min: 0 }}
                    />
                  </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />
                <SubsectionTitle>Opções de frete</SubsectionTitle>
                <MDBox display="flex" flexDirection="column" gap={1}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={Boolean(form.freteGratis)}
                        onChange={(e) =>
                          setForm((f: any) => ({
                            ...f,
                            freteGratis: e.target.checked,
                          }))
                        }
                        sx={switchAccentSx}
                      />
                    }
                    label="Frete grátis"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={Boolean(form.retiradaNoLocal)}
                        onChange={(e) =>
                          setForm((f: any) => ({
                            ...f,
                            retiradaNoLocal: e.target.checked,
                          }))
                        }
                        disabled={!form.eventoId}
                        sx={switchAccentSx}
                      />
                    }
                    label={`Retirada no local do evento${!form.eventoId ? " (vincule um evento acima)" : ""}`}
                  />
                </MDBox>

                <MDBox mt={3}>
                  <MDButton
                    variant="gradient"
                    color="dark"
                    onClick={onSalvarDados}
                    sx={saveButtonSx}
                  >
                    <Icon sx={{ mr: 0.5 }}>save</Icon>
                    {editMode ? "Salvar dados" : "Criar produto"}
                  </MDButton>
                </MDBox>
            </ProdutoFormSection>
          )}

          {/* Imagens */}
          {tab === 1 && (
            <ProdutoFormSection
              title="Imagens do produto"
              subtitle={`Upload para a variação padrão. Máximo ${PRODUTO_IMAGE_MAX_WIDTH}×${PRODUTO_IMAGE_MAX_HEIGHT} px.`}
              icon={<ImageOutlinedIcon />}
            >
              <MDTypography
                sx={{ mb: 2, color: "text.secondary" }}
                variant="body2"
              >
                Faça o upload das imagens do produto. Prefira fotos de boa
                qualidade para garantir uma melhor apresentação na loja. O
                tamanho final deve ser no máximo {PRODUTO_IMAGE_MAX_WIDTH}×
                {PRODUTO_IMAGE_MAX_HEIGHT} px. Imagens maiores podem ser
                recortadas no quadro de ajuste.
              </MDTypography>
              <MDTypography
                sx={{ mb: 2, color: "info.main", fontWeight: "medium" }}
                variant="caption"
                display="block"
              >
                As imagens enviadas nesta aba são vinculadas à{" "}
                <strong>variação padrão</strong>. Se você adicionar imagens
                específicas em outras variações (aba Variações → ícone de
                imagens), as imagens desta aba continuarão sendo as da variação
                padrão; as demais variações poderão ter fotos próprias.
              </MDTypography>

              {/* Galeria: imagens já enviadas da variação padrão (sem variacaoId = antigo, ou variacaoId = id da variação padrão) */}
              {form.imagens?.length > 0 &&
                (() => {
                  const variacaoPadraoId = (form.variacoes ?? []).find(
                    (v: any) => v.isPadrao
                  )?.id;
                  const imagensDoProduto = form.imagens.filter(
                    (img: any) =>
                      img.variacaoProdutoId === null ||
                      img.variacaoProdutoId === undefined ||
                      String(img.variacaoProdutoId) === String(variacaoPadraoId)
                  );

                  if (imagensDoProduto.length === 0) return null;

                  const selected =
                    imagensDoProduto[
                      Math.min(
                        selectedPreviewIndex,
                        imagensDoProduto.length - 1
                      )
                    ];

                  return (
                    <MDBox mt={2} mb={3}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        sx={{ mb: 1.5, color: "text.primary" }}
                      >
                        Imagens já enviadas
                      </MDTypography>

                      <Card
                        variant="outlined"
                        sx={{
                          overflow: "hidden",
                          borderRadius: 2,
                          backgroundColor: "grey.50",
                          border: "1px solid",
                          borderColor: "divider",
                        }}
                      >
                        <MDBox
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: 280,
                            maxHeight: 320,
                            p: 2,
                          }}
                        >
                          <img
                            src={selected?.url}
                            alt={selected?.textoAlternativo || "Preview"}
                            style={{
                              maxWidth: "100%",
                              maxHeight: 280,
                              objectFit: "contain",
                              borderRadius: 8,
                            }}
                          />
                        </MDBox>
                      </Card>

                      <MDBox
                        display="flex"
                        gap={1}
                        mt={1.5}
                        flexWrap="wrap"
                        justifyContent="center"
                      >
                        {imagensDoProduto.map((img: any, idx: number) => (
                          <MDBox
                            key={img.url}
                            onClick={() => setSelectedPreviewIndex(idx)}
                            sx={{
                              position: "relative",
                              width: 100,
                              height: 100,
                              borderRadius: 1,
                              overflow: "hidden",
                              border: "2px solid",
                              borderColor:
                                idx === selectedPreviewIndex
                                  ? PRODUTO_FORM_ACCENT
                                  : "divider",
                              cursor: "pointer",
                              flexShrink: 0,
                              "&:hover": {
                                borderColor: "rgba(249, 96, 48, 0.5)",
                              },
                            }}
                          >
                            <img
                              src={img.url}
                              alt={img.textoAlternativo || ""}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                            <MDButton
                              size="small"
                              variant="contained"
                              color="error"
                              onClick={(e) => {
                                e.stopPropagation();
                                onExcluirImagemGaleria(img);
                              }}
                              sx={{
                                position: "absolute",
                                bottom: 6,
                                right: 6,
                                minWidth: 28,
                                width: 28,
                                height: 28,
                                p: 0,
                                borderRadius: "6px",
                              }}
                            >
                              <Icon color="inherit" fontSize="large">
                                delete
                              </Icon>
                            </MDButton>
                          </MDBox>
                        ))}
                      </MDBox>
                    </MDBox>
                  );
                })()}

              {(() => {
                const MAX_IMAGENS_POR_VARIACAO = 5;
                const variacaoPadraoId = (form.variacoes ?? []).find(
                  (v: any) => v.isPadrao
                )?.id;
                const imagensVariacaoPadrao =
                  form.imagens?.filter(
                    (img: any) =>
                      img.variacaoProdutoId === null ||
                      img.variacaoProdutoId === undefined ||
                      String(img.variacaoProdutoId) === String(variacaoPadraoId)
                  ) ?? [];
                const maxNovos = Math.max(
                  0,
                  MAX_IMAGENS_POR_VARIACAO - imagensVariacaoPadrao.length
                );
                return (
                  <>
                    <MDTypography
                      variant="caption"
                      color="text.secondary"
                      display="block"
                      sx={{ mb: 1 }}
                    >
                      Máximo de {MAX_IMAGENS_POR_VARIACAO} imagens na variação
                      padrão.{" "}
                      {imagensVariacaoPadrao.length > 0 &&
                        `(${imagensVariacaoPadrao.length} já enviada(s), você pode adicionar até ${maxNovos}.)`}
                    </MDTypography>

                    <MDBox
                      display="flex"
                      alignItems="stretch"
                      gap={2}
                      mb={2}
                      flexDirection={{ xs: "column", sm: "row" }}
                    >
                      <MDBox
                        sx={{
                          width: { xs: "100%", sm: 140 },
                          height: 140,
                          border: "2px dashed",
                          borderColor: PRODUTO_FORM_ACCENT,
                          borderRadius: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          bgcolor: "grey.50",
                          flexShrink: 0,
                        }}
                      >
                        <MDTypography
                          variant="caption"
                          color="primary"
                          fontWeight="bold"
                          textAlign="center"
                        >
                          Área permitida
                        </MDTypography>
                        <MDTypography variant="caption" color="text" textAlign="center">
                          {PRODUTO_IMAGE_MAX_WIDTH} × {PRODUTO_IMAGE_MAX_HEIGHT}{" "}
                          px
                        </MDTypography>
                      </MDBox>

                      <MDBox flex={1} minWidth={0}>
                        <DropzoneGlobal
                          key={dropzoneKey}
                          accept="only-images"
                          maxFiles={maxNovos}
                          onFilesChange={processarArquivosImagem}
                        />
                      </MDBox>
                    </MDBox>

                    {arquivosParaUpload.length > 0 && (
                      <MDBox mt={2}>
                        <MDTypography variant="caption" color="text.secondary">
                          Prontas para envio ({arquivosParaUpload.length}):
                        </MDTypography>
                        <MDBox display="flex" gap={1} flexWrap="wrap" mt={1}>
                          {arquivosParaUpload.map((file, idx) => (
                            <MDBox
                              key={`${file.name}-${idx}`}
                              sx={{
                                width: 72,
                                height: 72,
                                borderRadius: 1,
                                overflow: "hidden",
                                border: "1px solid",
                                borderColor: "divider",
                              }}
                            >
                              <img
                                src={URL.createObjectURL(file)}
                                alt={file.name}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                                onLoad={(e) =>
                                  URL.revokeObjectURL(
                                    (e.target as HTMLImageElement).src,
                                  )
                                }
                              />
                            </MDBox>
                          ))}
                        </MDBox>
                      </MDBox>
                    )}
                  </>
                );
              })()}

              <MDBox mt={2}>
                <MDButton
                  variant="gradient"
                  color="dark"
                  onClick={onSalvarImagens}
                  disabled={savingImagens}
                  sx={saveButtonSx}
                >
                  Salvar imagens
                </MDButton>
              </MDBox>
            </ProdutoFormSection>
          )}

          {/* Especificações — formato backend: { chave, valor, ordem }[] */}
          {tab === 2 && (
            <ProdutoFormSection
              title="Especificações do produto"
              subtitle="Pares chave/valor (ex.: Tamanho / G, M, P). A ordem é enviada ao backend."
              icon={<ListAltOutlinedIcon />}
              action={
                <MDButton
                  size="small"
                  variant="outlined"
                  color="dark"
                  onClick={() =>
                    setEspecificacoes((v) => [
                      ...v,
                      {
                        chave: "",
                        valor: "",
                        ordem: v.length + 1,
                      },
                    ])
                  }
                >
                  <Icon>add</Icon>&nbsp;Adicionar
                </MDButton>
              }
            >
              {especificacoes.length === 0 ? (
                <MDBox sx={emptyStateSx}>
                  <MDTypography variant="body2" color="text.secondary">
                    Nenhuma especificação. Clique em &quot;Adicionar&quot; para
                    inserir.
                  </MDTypography>
                </MDBox>
              ) : (
                <MDBox component="ul" p={0} m={0} sx={{ listStyle: "none" }}>
                  {especificacoes.map((e, idx) => (
                    <MDBox
                      key={idx}
                      component="li"
                      mb={1.5}
                      p={1.5}
                      sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 1,
                        bgcolor: "grey.50",
                        display: "grid",
                        gridTemplateColumns: {
                          xs: "1fr",
                          sm: "60px 1fr 1fr auto",
                        },
                        gap: 2,
                        alignItems: "center",
                        minWidth: 0,
                      }}
                    >
                      <MDTypography
                        variant="caption"
                        color="text.secondary"
                        fontWeight="medium"
                        sx={{ order: { xs: 0, sm: 0 } }}
                      >
                        Ordem {e.ordem}
                      </MDTypography>
                      <FormField
                        label="Chave"
                        name={`espec_chave_${idx}`}
                        variant="outlined"
                        size="small"
                        value={e.chave}
                        placeholder="Ex: Tamanho"
                        onChange={(ev: any) =>
                          setEspecificacoes((arr) =>
                            arr.map((it, i) =>
                              i === idx ? { ...it, chave: ev.target.value } : it
                            )
                          )
                        }
                        InputLabelProps={{ shrink: true }}
                        sx={{ backgroundColor: "white", minWidth: 0 }}
                      />
                      <FormField
                        label="Valor"
                        name={`espec_valor_${idx}`}
                        variant="outlined"
                        size="small"
                        value={e.valor}
                        placeholder="Ex: G, M, P"
                        onChange={(ev: any) =>
                          setEspecificacoes((arr) =>
                            arr.map((it, i) =>
                              i === idx ? { ...it, valor: ev.target.value } : it
                            )
                          )
                        }
                        InputLabelProps={{ shrink: true }}
                        backgroundColor="white"
                        sx={{ backgroundColor: "white", minWidth: 0 }}
                      />
                      <MDBox
                        display="flex"
                        flexWrap="wrap"
                        gap={0.5}
                        alignItems="center"
                        justifyContent={{ xs: "flex-start", sm: "flex-end" }}
                        sx={{ minWidth: 0 }}
                      >
                        <MDButton
                          size="medium"
                          variant="text"
                          color="dark"
                          onClick={() =>
                            setEspecificacoes((arr) =>
                              moveItem(arr, idx, -1).map((it, i) => ({
                                ...it,
                                ordem: i + 1,
                              }))
                            )
                          }
                          disabled={idx === 0}
                        >
                          <Icon fontSize="small">arrow_upward</Icon>
                        </MDButton>
                        <MDButton
                          size="medium"
                          variant="text"
                          color="dark"
                          onClick={() =>
                            setEspecificacoes((arr) =>
                              moveItem(arr, idx, 1).map((it, i) => ({
                                ...it,
                                ordem: i + 1,
                              }))
                            )
                          }
                          disabled={idx === especificacoes.length - 1}
                        >
                          <Icon fontSize="small">arrow_downward</Icon>
                        </MDButton>
                        <MDButton
                          size="medium"
                          color="error"
                          variant="text"
                          onClick={() => removeEspecificacao(e.id, idx)}
                        >
                          <Icon fontSize="small">delete</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  ))}
                </MDBox>
              )}
              <MDBox mt={2}>
                <MDButton
                  variant="gradient"
                  color="dark"
                  onClick={onSalvarEspecificacoes}
                  disabled={!produtoPersistido}
                  sx={saveButtonSx}
                >
                  Salvar especificações
                </MDButton>
              </MDBox>
            </ProdutoFormSection>
          )}

          {/* Tabelas de tamanho — formato backend: { tabelas: [ { titulo, linhas: [ { campo, valor, ordem } ] } ] } */}
          {tab === 3 && (
            <ProdutoFormSection
              title="Tabelas de tamanho"
              subtitle="Cada tabela tem um título e linhas campo/valor com ordem enviada ao backend."
              icon={<StraightenOutlinedIcon />}
              action={
                <MDButton
                  size="small"
                  variant="outlined"
                  color="dark"
                  onClick={() =>
                    setTabelas((v) => [...v, { titulo: "", linhas: [] }])
                  }
                >
                  <Icon>add</Icon>&nbsp;Adicionar tabela
                </MDButton>
              }
            >
              {tabelas.length === 0 ? (
                <MDBox sx={emptyStateSx}>
                  <MDTypography variant="body2" color="text.secondary">
                    Nenhuma tabela. Clique em &quot;Adicionar tabela&quot; para
                    inserir.
                  </MDTypography>
                </MDBox>
              ) : (
                <MDBox component="ul" p={0} m={0} sx={{ listStyle: "none" }}>
                  {tabelas.map((tabela, tIdx) => (
                    <MDBox
                      key={tIdx}
                      component="li"
                      mb={3}
                      p={2}
                      sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 2,
                        bgcolor: "grey.50",
                      }}
                    >
                      <MDBox
                        display="flex"
                        flexWrap="wrap"
                        alignItems="center"
                        gap={2}
                        mb={2}
                        sx={{
                          display: "grid",
                          gridTemplateColumns: { xs: "1fr", sm: "1fr auto" },
                          gap: 2,
                          minWidth: 0,
                        }}
                      >
                        <FormField
                          label="Título da tabela"
                          name={`tabela_titulo_${tIdx}`}
                          variant="outlined"
                          size="small"
                          value={tabela.titulo}
                          placeholder="Ex: Tabela de Medidas"
                          onChange={(ev: any) =>
                            setTabelas((arr) =>
                              arr.map((t, i) =>
                                i === tIdx
                                  ? { ...t, titulo: ev.target.value }
                                  : t
                              )
                            )
                          }
                          InputLabelProps={{ shrink: true }}
                          sx={{ maxWidth: 400, minWidth: 0 }}
                        />
                        <MDBox
                          display="flex"
                          gap={0.5}
                          alignItems="center"
                          flexWrap="wrap"
                        >
                          <MDButton
                            size="medium"
                            variant="text"
                            color="dark"
                            onClick={() =>
                              setTabelas((arr) =>
                                arr.map((t, i) =>
                                  i === tIdx
                                    ? {
                                        ...t,
                                        linhas: [
                                          ...t.linhas,
                                          {
                                            campo: "",
                                            valor: "",
                                            ordem: t.linhas.length + 1,
                                          },
                                        ],
                                      }
                                    : t
                                )
                              )
                            }
                          >
                            <Icon fontSize="small">add</Icon>&nbsp;Linha
                          </MDButton>
                          <MDButton
                            size="medium"
                            color="error"
                            variant="text"
                            onClick={() =>
                              setTabelas((arr) =>
                                arr.filter((_, i) => i !== tIdx)
                              )
                            }
                          >
                            <Icon fontSize="small">delete</Icon>&nbsp;Remover
                            tabela
                          </MDButton>
                        </MDBox>
                      </MDBox>
                      {tabela.linhas.length === 0 ? (
                        <MDTypography variant="caption" color="text.secondary">
                          Nenhuma linha. Clique em &quot;Linha&quot; para
                          adicionar.
                        </MDTypography>
                      ) : (
                        <MDBox
                          component="ul"
                          p={0}
                          m={0}
                          sx={{ listStyle: "none" }}
                        >
                          {tabela.linhas.map((linha, lIdx) => (
                            <MDBox
                              key={lIdx}
                              component="li"
                              mb={1.5}
                              p={1.5}
                              sx={{
                                display: "grid",
                                gridTemplateColumns: {
                                  xs: "1fr",
                                  sm: "60px 1fr 1fr auto",
                                },
                                gap: 2,
                                alignItems: "center",
                                minWidth: 0,
                                border: "1px solid",
                                borderColor: "divider",
                                borderRadius: 1,
                                bgcolor: "background.paper",
                              }}
                            >
                              <MDTypography
                                variant="caption"
                                color="text.secondary"
                                fontWeight="medium"
                              >
                                Ordem {linha.ordem}
                              </MDTypography>
                              <FormField
                                label="Campo"
                                name={`linha_campo_${tIdx}_${lIdx}`}
                                variant="outlined"
                                size="small"
                                value={linha.campo}
                                placeholder="Ex: Largura (P)"
                                onChange={(ev: any) =>
                                  setTabelas((arr) =>
                                    arr.map((t, i) =>
                                      i === tIdx
                                        ? {
                                            ...t,
                                            linhas: t.linhas.map((l, j) =>
                                              j === lIdx
                                                ? {
                                                    ...l,
                                                    campo: ev.target.value,
                                                  }
                                                : l
                                            ),
                                          }
                                        : t
                                    )
                                  )
                                }
                                InputLabelProps={{ shrink: true }}
                                sx={{ minWidth: 0 }}
                              />
                              <FormField
                                label="Valor"
                                name={`linha_valor_${tIdx}_${lIdx}`}
                                variant="outlined"
                                size="small"
                                value={linha.valor}
                                placeholder="Ex: 40cm"
                                onChange={(ev: any) =>
                                  setTabelas((arr) =>
                                    arr.map((t, i) =>
                                      i === tIdx
                                        ? {
                                            ...t,
                                            linhas: t.linhas.map((l, j) =>
                                              j === lIdx
                                                ? {
                                                    ...l,
                                                    valor: ev.target.value,
                                                  }
                                                : l
                                            ),
                                          }
                                        : t
                                    )
                                  )
                                }
                                InputLabelProps={{ shrink: true }}
                                sx={{ minWidth: 0 }}
                              />
                              <MDBox
                                display="flex"
                                flexWrap="wrap"
                                gap={0.5}
                                alignItems="center"
                                sx={{ minWidth: 0 }}
                              >
                                <MDButton
                                  size="medium"
                                  variant="text"
                                  color="dark"
                                  onClick={() =>
                                    setTabelas((arr) =>
                                      arr.map((t, i) =>
                                        i === tIdx
                                          ? {
                                              ...t,
                                              linhas: moveItem(
                                                t.linhas,
                                                lIdx,
                                                -1
                                              ).map((l, j) => ({
                                                ...l,
                                                ordem: j + 1,
                                              })),
                                            }
                                          : t
                                      )
                                    )
                                  }
                                  disabled={lIdx === 0}
                                >
                                  <Icon fontSize="small">arrow_upward</Icon>
                                </MDButton>
                                <MDButton
                                  size="medium"
                                  variant="text"
                                  color="dark"
                                  onClick={() =>
                                    setTabelas((arr) =>
                                      arr.map((t, i) =>
                                        i === tIdx
                                          ? {
                                              ...t,
                                              linhas: moveItem(
                                                t.linhas,
                                                lIdx,
                                                1
                                              ).map((l, j) => ({
                                                ...l,
                                                ordem: j + 1,
                                              })),
                                            }
                                          : t
                                      )
                                    )
                                  }
                                  disabled={lIdx === tabela.linhas.length - 1}
                                >
                                  <Icon fontSize="small">arrow_downward</Icon>
                                </MDButton>
                                <MDButton
                                  size="medium"
                                  color="error"
                                  variant="text"
                                  onClick={() =>
                                    setTabelas((arr) =>
                                      removerLinhaTabela(arr, tIdx, lIdx)
                                    )
                                  }
                                >
                                  <Icon fontSize="small">delete</Icon>
                                </MDButton>
                              </MDBox>
                            </MDBox>
                          ))}
                        </MDBox>
                      )}
                    </MDBox>
                  ))}
                </MDBox>
              )}
              <MDBox mt={2}>
                <MDButton
                  variant="gradient"
                  color="dark"
                  onClick={onSalvarTabela}
                  disabled={!produtoPersistido}
                  sx={saveButtonSx}
                >
                  Salvar tabelas
                </MDButton>
              </MDBox>
            </ProdutoFormSection>
          )}

          {/* Variações */}
          {tab === 4 && (
            <ProdutoFormSection
              title="Variações"
              subtitle="SKUs, preços, estoque e imagens por combinação de atributos."
              icon={<Inventory2OutlinedIcon />}
              noPadding
            >
            <VariacoesPage
              produtoId={String(produtoId ?? (form as any).id ?? "")}
              produtoSlugOuNome={form.slug || form.nome || "PROD"}
              produtoNome={form.nome || form.slug || "PROD"}
              marcaNome={
                marcas.find((m) => m.id === form.marcaId)?.nome ?? "GEN"
              }
              variacoesIniciais={variacoes}
              imagensProduto={form.imagens ?? []}
              onVariacoesSalvas={(v: IVariacaoProdutoState[]) =>
                setVariacoes(v)
              }
              onRefetchProduto={getDetalhesProduto}
              precoPadrao={
                form.emPromocao
                  ? currencyToNumber(form.preco ?? "0") || 0
                  : currencyToNumber(form.precoOriginal ?? "0") || 0
              }
              precoOriginalPadrao={
                form.emPromocao
                  ? currencyToNumber(form.precoOriginal ?? "0") || 0
                  : 0
              }
              precoCustoPadrao={(() => {
                const v = currencyToNumber(form.precoCusto ?? "0");
                return Number.isFinite(v) && v > 0 ? v : null;
              })()}
            />
            </ProdutoFormSection>
          )}

          {/* Categorias */}
          {tab === 5 && (
            <ProdutoFormSection
              title="Categorias do produto"
              subtitle="Selecione as categorias em que este produto será exibido na loja."
              icon={<CategoryOutlinedIcon />}
              action={
                <MDButton
                  size="small"
                  variant="outlined"
                  color="dark"
                  onClick={() => navigate("/loja/categorias")}
                >
                  <Icon sx={{ mr: 0.5 }}>category</Icon>
                  Gerenciar categorias
                </MDButton>
              }
            >
                <Grid container spacing={3}>
                  <Grid item xs={12} md={7}>
                    <MDTypography
                      variant="caption"
                      color="text"
                      fontWeight="medium"
                      sx={{
                        textTransform: "uppercase",
                        letterSpacing: 1,
                        display: "block",
                        mb: 1.5,
                      }}
                    >
                      Árvore de categorias
                    </MDTypography>
                    <MDBox
                      sx={{
                        maxHeight: 380,
                        overflowY: "auto",
                        p: 1.5,
                        borderRadius: 2,
                        bgcolor: "grey.50",
                        border: "1px solid",
                        borderColor: "divider",
                      }}
                    >
                      <List component="div" disablePadding>
                        {categoriasArvore.map((node) => (
                          <CategoriaTreeItem
                            key={node.id}
                            categoria={node}
                            level={0}
                            expanded={categoriasExpanded}
                            onToggle={toggleCategoriasExpanded}
                            selecionadas={categoriasSel}
                            onToggleCategoria={(cat) => {
                              const ids = getIdsComDescendentes(cat);
                              setCategoriasSel((prev) =>
                                prev.includes(cat.id)
                                  ? prev.filter((x) => !ids.includes(x))
                                  : [...new Set([...prev, ...ids])]
                              );
                            }}
                          />
                        ))}
                      </List>
                      {categoriasArvore.length === 0 && (
                        <MDBox sx={{ ...emptyStateSx, py: 3 }}>
                          <CategoryOutlinedIcon
                            sx={{ fontSize: 40, color: "grey.400", mb: 1, display: "block", mx: "auto" }}
                          />
                          <MDTypography variant="body2" color="text.secondary">
                            Nenhuma categoria cadastrada.
                          </MDTypography>
                        </MDBox>
                      )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <MDTypography
                      variant="caption"
                      color="text"
                      fontWeight="medium"
                      sx={{
                        textTransform: "uppercase",
                        letterSpacing: 1,
                        display: "block",
                        mb: 1.5,
                      }}
                    >
                      Selecionadas ({categoriasSel.length})
                    </MDTypography>
                    <MDBox
                      sx={{
                        minHeight: 120,
                        p: 2,
                        borderRadius: 2,
                        bgcolor: "grey.50",
                        border: "1px solid",
                        borderColor: "divider",
                      }}
                    >
                      {categoriasSel.length === 0 ? (
                        <MDTypography variant="body2" color="text.secondary">
                          Nenhuma categoria selecionada.
                        </MDTypography>
                      ) : (
                        <MDBox display="flex" flexWrap="wrap" gap={1}>
                          {flattenCategorias(categoriasArvore)
                            .filter((c) => categoriasSel.includes(c.id))
                            .map((c) => (
                              <Chip
                                key={c.id}
                                label={c.nome}
                                size="small"
                                onDelete={() =>
                                  setCategoriasSel((prev) =>
                                    prev.filter((x) => x !== c.id)
                                  )
                                }
                                sx={{ fontWeight: 500 }}
                              />
                            ))}
                        </MDBox>
                      )}
                    </MDBox>
                  </Grid>
                </Grid>
                <MDBox mt={3} display="flex" gap={2}>
                  <MDButton
                    variant="gradient"
                    color="dark"
                    onClick={onSalvarCategorias}
                    startIcon={<Icon>save</Icon>}
                    sx={saveButtonSx}
                  >
                    Salvar categorias
                  </MDButton>
                </MDBox>
            </ProdutoFormSection>
          )}

          {/* Cupons */}
          {tab === 6 && (
            <ProdutoFormSection
              title="Cupons do produto"
              subtitle="Cupons de desconto vinculados a este item da loja."
              icon={<LocalOfferOutlinedIcon />}
              noPadding
            >
              <CuponsPage
                produtoId={String(produtoId ?? (form as any).id ?? "")}
              />
            </ProdutoFormSection>
          )}
        </>
      )}
      <ProdutoImageCropModal
        open={cropModalOpen}
        file={cropFile}
        maxWidth={PRODUTO_IMAGE_MAX_WIDTH}
        maxHeight={PRODUTO_IMAGE_MAX_HEIGHT}
        onClose={handleCropClose}
        onConfirm={handleCropConfirm}
        onError={(text) =>
          setMessage(dispatch, { open: true, severity: "error", text })
        }
      />

      <Dialog
        open={openMarcaModal}
        onClose={() => !savingMarca && setOpenMarcaModal(false)}
        maxWidth={false}
        fullWidth
        PaperProps={{ sx: modalPaperSx }}
      >
        <Box sx={modalHeaderSx}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <BrandingWatermarkOutlinedIcon sx={{ fontSize: 32, opacity: 0.9 }} />
              <MDTypography variant="h6" fontWeight="bold" color="inherit">
                Nova marca
              </MDTypography>
            </Stack>
            <IconButton
              onClick={() => !savingMarca && setOpenMarcaModal(false)}
              sx={{ color: "inherit" }}
              aria-label="Fechar"
            >
              <Icon>close</Icon>
            </IconButton>
          </Stack>
        </Box>
        <MDBox px={3} py={2}>
            <FormField
              label="Nome da marca"
              value={novaMarcaNome}
              onChange={(e: any) => setNovaMarcaNome(e.target.value)}
              variant="outlined"
              fullWidth
              autoFocus
              InputLabelProps={{ shrink: true }}
              onKeyDown={(e: any) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSalvarNovaMarca();
                }
              }}
            />
        </MDBox>
        <MDBox
          px={3}
          py={2}
          display="flex"
          gap={1}
          justifyContent="flex-end"
          borderTop="1px solid"
          borderColor="grey.200"
        >
          <MDButton
            variant="outlined"
            color="dark"
            onClick={() => setOpenMarcaModal(false)}
            disabled={savingMarca}
          >
            Cancelar
          </MDButton>
          <MDButton
            variant="gradient"
            color="dark"
            onClick={handleSalvarNovaMarca}
            disabled={savingMarca}
            sx={saveButtonSx}
          >
            {savingMarca ? "Salvando…" : "Salvar"}
          </MDButton>
        </MDBox>
      </Dialog>
    </LojaPageContainer>
  );
}
